module.exports = __webpack_public_path__ + "img/logomarca.ae8092bf.png";